module.exports = __webpack_public_path__ + "static/media/seta.3c491d66.svg";